<template>
  <svg
    width="51"
    height="51"
    viewBox="0 0 51 51"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M25.5 44.4733C16.3408 44.4733 8.91685 37.0493 8.91685 27.8902C8.91685 18.7311 16.3408 11.2786 25.5 11.2786C34.6591 11.2786 42.0831 18.7026 42.0831 27.8618C42.0831 28.6582 42.0262 29.4262 41.9124 30.1658H46.6342C46.6911 29.5969 46.748 29.028 46.748 28.4306C46.8902 23.3675 45.212 18.4466 42.0546 14.4929L44.7284 11.8191C45.1835 11.364 45.1835 10.6244 44.7284 10.1693L43.0502 8.49109C42.5951 8.03597 41.8271 8.03597 41.372 8.49109L38.7551 11.2786C36.252 9.25909 33.3506 7.80842 30.2217 7.06886V4.16753C30.2217 2.85909 29.1693 1.80664 27.8608 1.80664H23.1391C21.8306 1.80664 20.7782 2.85909 20.7782 4.16753V7.06886C11.0502 9.28753 4.16663 17.9062 4.16663 27.8618C4.30885 39.3533 13.4111 48.74 24.8742 49.1951H25.4715C26.2111 49.1951 26.9222 49.1666 27.6333 49.0813V44.3026C26.9506 44.4164 26.2395 44.4733 25.5 44.4733Z"
      fill="white"
    />
    <path
      d="M24.5898 16.0284C23.9356 16.0284 23.3951 16.5689 23.3951 17.2231V29.0844C23.3951 29.7387 23.9356 30.2791 24.5898 30.2791H26.3818C27.036 30.2791 27.5765 29.7387 27.5765 29.0844V17.1947C27.5765 16.5404 27.036 16 26.3818 16H24.5898V16.0284Z"
      fill="white"
    />
    <g clip-path="url(#clip0_5277_10977)">
      <path
        d="M38.5 33.5C34.0815 33.5 30.5 37.0815 30.5 41.5C30.5 45.9185 34.0815 49.5 38.5 49.5C42.9185 49.5 46.5 45.9185 46.5 41.5C46.5 37.0815 42.9185 33.5 38.5 33.5ZM38.5 48C34.91 48 32 45.09 32 41.5C32 37.91 34.91 35 38.5 35C42.09 35 45 37.91 45 41.5C45 45.09 42.09 48 38.5 48ZM35.5 38.5H41.5V44.5H35.5V38.5Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_5277_10977">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="translate(30.5 33.5)"
        />
      </clipPath>
    </defs>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'IconEndShift',
} as DefineComponent
</script>
